import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Container, Divider, Paper } from "@mui/material";
import performRequest from "network/perform-request";
import { organizationShowBySlugRoute } from "network/api-routes";
import RevaText from "components/common/RevaText";
import OrganizationCalendar from "./OrganizationCalendar";
import PastCompetitions from "./OrganizationPastEvents";
import OrganizationRankingsList from "./OrganizationRankingsList";
import ErrorPage from "../ErrorPages/404";
import Footer from "./OrganizationFooter";

export default function OrganizationLanding() {
  const { organizationSlug } = useParams();
  const [organization, setOrganization] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [activeCompetitions, setActiveCompetitions] = useState([]);
  const [finishedCompetitions, setFinishedCompetitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    performRequest("GET", `${organizationShowBySlugRoute}/${organizationSlug}`)
      .then((res) => {
        setOrganization(res.data.organization);
        setClassifications(res.data.classifications);
        setActiveCompetitions(res.data.active_competitions);
        setFinishedCompetitions(res.data.finished_competitions);
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          setError(true);
        } else {
          // manejar otro tipo de error
        }
      })
      .finally(() => setLoading(false));
  }, [organizationSlug]);

  if (loading) return <CircularProgress />;
  if (error) return <ErrorPage />;

  return (
    <Container maxWidth="lg" sx={{ margin: "auto", px: { xs: 0, md: 4 }, flexGrow: 1 }}>
      <Box
        className="background background-filter"
        justifyContent="center"
        sx={{
          backgroundImage: `url('${organization.full_cover_url}')  !important`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          width: "100% !important",
          alignItems: "center",
          backgroundPosition: "center",
          p: { xs: 4, md: 16 },
        }}
      >
        <span>
          <RevaText variant="h1" textAlign="center">
            {organization.name}
          </RevaText>
        </span>
      </Box>
      <Paper sx={{ p: 4, borderRadius: 0 }} elevation={6}>
        <OrganizationCalendar competitions={[...finishedCompetitions, ...activeCompetitions]} />
        <PastCompetitions competitions={finishedCompetitions} />
        <Divider sx={{ my: 4 }} />
        <OrganizationRankingsList classifications={classifications} />
      </Paper>
      {/* <NewsSection news={data.news} /> */}
      <Footer />
    </Container>
  );
}
